import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import api, { formatApiError } from "../api";
import AuthLayout from "../components/AuthLayout";
import { Button, Input, Label } from "../components/ui/Primitives";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success(t("auth.reset_sent"));
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={t("auth.forgot_title")}
      subtitle={t("auth.forgot_subtitle")}
      footer={
        <Link to="/login" data-testid="link-back-to-login" className="text-brand hover:text-brand-hover font-medium">
          ← {t("auth.back_to_login")}
        </Link>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
        <div>
          <Label htmlFor="email">{t("common.email")}</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
          {loading ? t("common.loading") : t("auth.submit_forgot")}
        </Button>

        {done && (
          <div className="text-sm text-ink-secondary bg-bg-surface border border-white/10 rounded-md px-3 py-2.5" data-testid="forgot-success">
            <p>{t("auth.reset_sent")}</p>
            <p className="text-[11px] text-ink-muted mt-1.5">{t("auth.reset_check_inbox", "Prüfen Sie auch Ihren Spam-Ordner. Der Link ist 1 Stunde gültig.")}</p>
          </div>
        )}
      </form>
    </AuthLayout>
  );
}
